<template>
<BootstrapDialog title="分配阅卷老师" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <form role="form" class="form-horizontal">
		            <div class="col-sm-12">
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required">*</span>阅卷老师（按Ctrl键多选）</label>
		                    <div class="col-sm-8">
			                    <select name="jsids" multiple="multiple" v-model="model.jsids" v-validate="{required:true}" data-vv-as="阅卷老师" class="form-control">
			                        <option value="">-请选择-</option>
			                        <option v-for="item in lsList" :key="item.id" :value="item.id">{{item.xm}}</option>
			                    </select>
			                    <span class="error_validate_msg"><em>{{ errors.first('jsids') }}</em></span>
			                </div>
		                </div>
		            </div>
		        </form>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-primary" type="button" @click="save()">保存</button>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 综合测验  批量克隆
     */
    export default {
        name: 'ExamPaperPlkl',
        components: {
        },
        data: function () {
            return {
            	lsList: [],// 讲师
            	sjids:'',
                model: {
                    jsids: []// 讲师
                }
            }
        },
        methods: {
			reset:function(){
				this.lsList =  [];// 讲师
				this.sjids = '';
				this.model = {
				    jsids: []// 讲师
				}
			},
			async open(params){
				this.sjids = params.ids;
				let res =await this.$http.post('/htgl/biz/zypx/yjls/jslb');
				if(res.data){
					this.lsList = res.data;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/biz/zypx/yjls/xz', {sjids : this.sjids,jsids : this.model.jsids.join(",")}).then(res=>{
                            if(res.data==true){
								this.$success('操作成功',()=>{
									this.close();
									this.$parent.search();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }
    }
</script>